import styled from '@emotion/styled';
import { colors, getFontStyle, getSpacing } from '@cabonline/ui-shared';
import { ElementType } from 'react';

interface StyledSectionTitleProps {
  as: ElementType;
}

// Intentionally uses a fixed visual size (xl/extraBold) regardless of heading
// level — the `as` prop is purely semantic for document outline.
export const StyledSectionTitle = styled.h2<StyledSectionTitleProps>`
  ${getFontStyle('xl', 'extraBold')};
  color: ${colors.black};
  line-height: 28px;
  margin: 0 0 ${getSpacing('s')} 0;
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
